import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-widgets/dist/css/react-widgets.css";

toast.configure({ autoClose: 10000, position: toast.POSITION.BOTTOM_RIGHT });

const successToast = (message, options = {}) =>
  toast(message, {
    className: "alert alert-success fade show",
    progressClassName: "progress-bar bg-success",
    ...options,
  });

const errorToast = (message, options = {}) =>
  toast(message, {
    className: "alert alert-danger fade show",
    progressClassName: "progress-bar bg-danger",
    ...options,
  });

const warningToast = (message, options = {}) =>
  toast(message, {
    className: "alert alert-warning fade show",
    progressClassName: "progress-bar bg-warning",
    ...options,
  });

export { successToast, errorToast, warningToast };
